var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockImgSix(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 807 807",
    style: {
      enableBackground: "new 0 0 807 807"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:22;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 403.5,
    cy: 403.5,
    r: 392.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 687.5,
    cy: 130.5,
    r: 92.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.8,393.8H283c-23.2,0-42-18.9-42-42V283c0-23.2,18.9-42,42-42h68.8c23.2,0,42,18.9,42,42v68.8 C393.8,375,375,393.8,351.8,393.8z M283,261.4c-11.9,0-21.6,9.7-21.6,21.6v68.8c0,11.9,9.7,21.6,21.6,21.6h68.8 c11.9,0,21.6-9.7,21.6-21.6V283c0-11.9-9.7-21.6-21.6-21.6H283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525,393.8h-68.8c-23.2,0-42-18.9-42-42V283c0-23.2,18.9-42,42-42H525c23.2,0,42,18.9,42,42v68.8 C567,375,548.1,393.8,525,393.8z M456.2,261.4c-11.9,0-21.6,9.7-21.6,21.6v68.8c0,11.9,9.7,21.6,21.6,21.6H525 c11.9,0,21.6-9.7,21.6-21.6V283c0-11.9-9.7-21.6-21.6-21.6H456.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.6,567c-42.1,0-76.4-34.3-76.4-76.4s34.3-76.4,76.4-76.4s76.4,34.3,76.4,76.4S532.7,567,490.6,567z  M490.6,434.6c-30.9,0-56,25.1-56,56s25.1,56,56,56s56-25.1,56-56S521.5,434.6,490.6,434.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.8,567H283c-23.2,0-42-18.9-42-42v-68.8c0-23.2,18.9-42,42-42h68.8c23.2,0,42,18.9,42,42V525 C393.8,548.1,375,567,351.8,567z M283,434.6c-11.9,0-21.6,9.7-21.6,21.6V525c0,11.9,9.7,21.6,21.6,21.6h68.8 c11.9,0,21.6-9.7,21.6-21.6v-68.8c0-11.9-9.7-21.6-21.6-21.6H283z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockImgSix);
export default __webpack_public_path__ + "static/media/block-img-six.557675e76e0a4408255cc9601bdd36e7.svg";
export { ForwardRef as ReactComponent };